import dayjs from "dayjs"
import { localisedValue } from "utils"
export const getAddTaskInitialValues = lead => {
  let preFilledObject = {
    task: null,
    subTask: null,
    subofSubTask: null,
    nextTask: null,
  }

  if (localisedValue({ object: lead?.inquiryStatusDetails, key: "taskStatusParent" }) === 24) {
    preFilledObject.task = null
    preFilledObject.subTask = null
    preFilledObject.subofSubTask = null
    preFilledObject.nextTask = null
  } else if (localisedValue({ object: lead?.inquiryStatusDetails, key: "taskStatusGreatGrandParent" }) !== 0) {
    preFilledObject.task = localisedValue({ object: lead?.inquiryStatusDetails, key: "taskStatusGreatGrandParent" })
    preFilledObject.subTask = localisedValue({ object: lead?.inquiryStatusDetails, key: "taskStatusGrandParent" })
    preFilledObject.subofSubTask = localisedValue({ object: lead?.inquiryStatusDetails, key: "taskStatusParent" })
    preFilledObject.subLocation = localisedValue({ object: lead?.inquiryStatusDetails, key: "taskStatusId" })
    preFilledObject.nextTask = localisedValue({ object: lead?.inquiryStatusDetails, key: "nextStatusId" })
  } else if (localisedValue({ object: lead?.inquiryStatusDetails, key: "taskStatusGrandParent" }) !== 0) {
    preFilledObject.task = localisedValue({ object: lead?.inquiryStatusDetails, key: "taskStatusGrandParent" })
    preFilledObject.subTask = localisedValue({ object: lead?.inquiryStatusDetails, key: "taskStatusParent" })
    preFilledObject.subofSubTask = localisedValue({ object: lead?.inquiryStatusDetails, key: "taskStatusId" })
    preFilledObject.nextTask = localisedValue({ object: lead?.inquiryStatusDetails, key: "nextStatusId" })
  } else {
    preFilledObject.task = localisedValue({ object: lead?.inquiryStatusDetails, key: "taskStatusParent" })
    preFilledObject.subTask = localisedValue({ object: lead?.inquiryStatusDetails, key: "taskStatusId" })
    preFilledObject.nextTask = localisedValue({ object: lead?.inquiryStatusDetails, key: "nextStatusId" })
  }

  const lastTask = lead?.tasks?.find(item => item.hasOwnProperty("todoDetails"))

  return {
    task: preFilledObject.task,
    subTask: preFilledObject.subTask,
    subofSubTask: preFilledObject.subofSubTask,
    subLocation: preFilledObject?.subLocation,
    nextTask: preFilledObject.nextTask !== 0 ? preFilledObject.nextTask : null,
    project: lead?.Project?.name ?? null,
    verifyMeeting: "",
    showOtpfield: null,
    leadsClassification:
      localisedValue({ object: lead?.inquiry?.InternalInquiryClassification, key: "id" })?.toString() || "",
    tsrClassification: localisedValue({ object: lead?.inquiry?.TSRClassification, key: "id" })?.toString() || "",
    completionDate: !!lead?.isEditable ? dayjs(lastTask?.deadline) : dayjs(),
    deadLine:
      !!lead?.isEditable && lastTask?.todoDetails?.nextStatusDeadline
        ? dayjs(lastTask?.todoDetails?.nextStatusDeadline)
        : dayjs(),
    attachment: lastTask?.Attachments || [],
    dateSlot: lastTask?.todoDetails?.nextStatusDeadline ? dayjs(lastTask?.todoDetails?.nextStatusDeadline) : dayjs(),
    timeSlot: lastTask?.Event && [dayjs(lastTask?.Event?.startTimeStamp), dayjs(lastTask?.Event?.endTimeStamp)],
  }
}
